/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function TriangleOutlineIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "triangle-outline", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M20.5 18.5H4.5L12.5 5.5L20.5 18.5Z", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(TriangleOutlineIcon);
export default ForwardRef;
//# sourceMappingURL=triangleOutlineIcon.js.map